import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { NgxsModule } from "@ngxs/store";

import { CardOrderModule } from "../card-order/card-order.module";
import { CardOrderComponent } from "../card-order/components/card-order.component";
import { ApplicationPaths } from "../constants/application-paths";
import { Id06ConsentComponent } from "../id06-consent/components/id06-consent.component";
import { Id06ConsentModule } from "../id06-consent/id06-consent.module";
import { SharedModule } from "../shared/shared.module";
import { moduleTranslationProviderFactory } from "../translation/scope-loader";
import { AppAuthModule } from "./../auth/auth.module";
import { HomeNewsComponent } from "./components/home-news/home-news.component";
import { HomeNotificationsComponent } from "./components/home-notifications/home-notifications.component";
import { HomeComponent } from "./components/home.component";
import { HomeState } from "./state/home.state";
import { SSGConsentComponent } from "../ssg-consent/components/ssg-consent.component";
import { SSGConsentModule } from "../ssg-consent/ssg-consent.module";

const routes: Routes = [
    {
        path: "",
        pathMatch: "full",
        component: HomeComponent,
    },
    { path: ApplicationPaths.CardOrder, data: { title: "cardOrder.title" }, component: CardOrderComponent },
    { path: ApplicationPaths.Id06Consent, data: { title: "id06Consent.title" }, component: Id06ConsentComponent },
    { path: ApplicationPaths.SsgConsent, data: { title: "ssgConsent.title" }, component: SSGConsentComponent },
];

@NgModule({
    declarations: [HomeComponent, HomeNewsComponent, HomeNotificationsComponent],
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        NgxsModule.forFeature([HomeState]),
        AppAuthModule,
        CardOrderModule,
        Id06ConsentModule,
        SSGConsentModule,
        SharedModule,
    ],
    providers: [moduleTranslationProviderFactory("home")],
})
export class HomeModule {}
